"use client";

/**
 * Ayuda 6.4 — FAQ en acordeón + CTA de soporte.
 */

import { useState } from "react";
import Link from "next/link";

import { BottomNav, HeaderTitulo } from "@/components/app/chrome";
import { IconoLupa } from "@/components/app/iconos";

const FAQS = [
  {
    q: "¿Cuánto duran los boots?",
    a: "3 meses en el congelador. Una vez licuado, tómalo dentro de las 2 horas.",
  },
  {
    q: "¿Puedo pagar con tarjeta?",
    a: "Por ahora solo transferencia bancaria: transfieres, subes el comprobante y lo validamos en minutos.",
  },
  {
    q: "Llegué y no estaba, ¿qué pasa?",
    a: "Te escribimos por WhatsApp para reprogramar la entrega en la siguiente ruta de tu zona, sin costo extra la primera vez.",
  },
  {
    q: "¿Un boot reemplaza una comida?",
    a: "No. Es un complemento de fruta y verdura real; acompáñalo con tu alimentación normal.",
  },
  {
    q: "¿Cómo cambio mi zona?",
    a: "En Mi cuenta → Mis direcciones puedes agregar una dirección en otra zona de cobertura y usarla en tu próximo pedido.",
  },
];

export function AyudaCliente() {
  const [abierta, setAbierta] = useState(0);
  const [q, setQ] = useState("");
  const visibles = FAQS.filter((f) =>
    `${f.q} ${f.a}`.toLowerCase().includes(q.trim().toLowerCase()),
  );

  return (
    <>
      <HeaderTitulo titulo="Ayuda" />
      <main className="anim-bz-in min-h-(--alto-app) px-6 pt-[100px] pb-[62px]">
        <div className="pt-[22px] pb-[30px]">
          <div className="flex h-[52px] items-center gap-2.5 rounded-[26px] bg-humo px-5">
            <IconoLupa color="rgba(34,31,31,.5)" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Buscar en ayuda"
              className="min-w-0 flex-1 border-0 bg-transparent text-base outline-0 placeholder:text-tinta/50"
            />
          </div>

          <div className="mt-5 flex flex-col gap-2.5">
            {visibles.map((f) => {
              const i = FAQS.indexOf(f);
              const activa = abierta === i;
              return (
                <button
                  key={f.q}
                  type="button"
                  onClick={() => setAbierta(activa ? -1 : i)}
                  className="rounded-[20px] border border-black/5 bg-white p-[18px] text-left"
                >
                  <span className="flex justify-between gap-3">
                    <span className="font-app text-[15px] font-semibold">{f.q}</span>
                    <span className="text-tinta/35">{activa ? "−" : "+"}</span>
                  </span>
                  {activa && (
                    <span className="anim-bz-up mt-2.5 block text-sm leading-[21px] text-tinta/65">
                      {f.a}
                    </span>
                  )}
                </button>
              );
            })}
          </div>

          <Link href="/contacto" className="mt-5 block rounded-3xl bg-bosque p-5">
            <span className="block font-app text-[17px] font-semibold text-white">
              No encuentro mi respuesta
            </span>
            <span className="mt-1.5 block text-[13px] text-white/70">
              Escríbenos por WhatsApp, contestamos de 8 am a 7 pm.
            </span>
          </Link>
        </div>
      </main>
      <BottomNav />
    </>
  );
}
